import { useDispatch } from 'react-redux'
import { useQueryClient } from '@tanstack/react-query'
import ListingHiddenModalComponent from '@/components/listing-hidden-modal'
import { useListingData } from '../context/listing-data'

interface Props {
  visible: boolean
  onClose: () => void
}

export const ListingHiddenModal = ({ visible, onClose }: Props) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  const { listingId, isImported, tags, link } = useListingData()

  const handleClick = async () => {
    isImported
      ? window.open(link, '_blank')
      : await dispatch.listing.update({
          listing_id: listingId,
          is_hidden: 0
        })
    queryClient.invalidateQueries({ queryKey: ['sponsored-listings'] })
    queryClient.invalidateQueries({ queryKey: ['my-listings', 'livrent'], exact: true })
  }

  return (
    <ListingHiddenModalComponent
      visible={visible}
      onClose={onClose}
      onClick={handleClick}
      isImported={isImported ?? false}
      tag={tags}
    />
  )
}
